import { ComponentPropsWithoutRef, useState } from 'react'

export enum EEditMode {
  Edit,
  View,
}

interface Props extends Omit<ComponentPropsWithoutRef<'div'>, 'children'> {
  children: ({
    editMode,
    setEditMode,
  }: {
    editMode: EEditMode
    setEditMode: (editMode: EEditMode) => void
  }) => React.ReactNode
}

export const ToggleEdit = ({ children }: Props): JSX.Element => {
  const [editMode, setEditMode] = useState(EEditMode.View)

  return <>{children({ editMode, setEditMode })}</>
}
